import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  MapPin, Users, Megaphone, Tag, Building2, Loader2, MousePointerClick,
} from 'lucide-react';
import { AdminLayout } from '../components/AdminLayout';
import adminApi from '../lib/adminApi';

function StatCard({ icon: Icon, label, value, sub, to, color = '#1D9E75' }) {
  const Wrap = to ? Link : 'div';
  return (
    <Wrap
      to={to}
      className="bg-white rounded-2xl border border-gray-100 p-5 hover:border-[#1D9E75]/30 hover:shadow-sm transition-all flex items-start gap-3 block"
    >
      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${color}1A` }}>
        <Icon size={18} style={{ color }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-gray-500 mb-0.5">{label}</p>
        <p className="text-2xl font-bold text-gray-900 leading-tight" style={{ fontFamily: "'Work Sans', sans-serif" }}>
          {value}
        </p>
        {sub && <p className="text-[11px] text-gray-400 mt-1">{sub}</p>}
      </div>
    </Wrap>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get('/admin/stats')
      .then(res => setStats(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Dashboard">
      {loading || !stats ? (
        <div className="py-20 text-center text-gray-400 flex items-center justify-center gap-2">
          <Loader2 size={16} className="animate-spin" />
          Carregando...
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <StatCard
            icon={MapPin} label="Cidades ativas" value={stats.cidades.ativas}
            sub={`${stats.cidades.total} cadastradas`} to="/admin/cidades" color="#1D9E75"
          />
          <StatCard
            icon={Users} label="Profissionais" value={stats.profissionais.ativos}
            sub={`${stats.profissionais.premium} premium · ${stats.profissionais.total} total`}
            to="/admin/profissionais" color="#0F6E56"
          />
          <StatCard
            icon={Megaphone} label="Anúncios ativos" value={stats.anuncios.ativos}
            sub={`${stats.anuncios.pendentes} pendentes`} to="/admin/anuncios" color="#F59E0B"
          />
          <StatCard
            icon={MousePointerClick} label="Cliques em anúncios" value={stats.anuncios.totalCliques}
            sub="acumulado" color="#3B82F6"
          />
          <StatCard
            icon={Tag} label="Promoções" value={stats.promocoes.total}
            sub={`${stats.promocoes.pendentes} pendentes`} to="/admin/promocoes" color="#EF4444"
          />
          <StatCard
            icon={Building2} label="Anunciantes" value={stats.anunciantes.total}
            to="/admin/anunciantes" color="#8B5CF6"
          />
        </div>
      )}
    </AdminLayout>
  );
}
